<!-- <p-chips [formControl]="this.form.get('tagsControl')" (onAdd)="addNovaTag($event)"></p-chips> -->
<div>
  <mat-form-field class="w-100 mb-2" appearance="outline">
    <mat-label>{{ placeholder }}</mat-label>
    <mat-chip-set #chipListTag>
      <mat-chip
        *ngFor="let tag of formTag.controls"
        [removable]="true"
        [ngStyle]="{ 'background-color': color ? color : tag.value.color, color: 'white' }"
        class="chip-item"
        (removed)="removerTag(tag)"
      >
        {{ tag.value.value }}
        <mat-icon
          matChipRemove
          [ngStyle]="{ 'background-color': color ? color : tag.value.color, color: 'white' }"
          >cancel</mat-icon
        >
      </mat-chip>
      <input
        class="field-tag"
        #input
        autocomplete="off"
        [readonly]="(formTag.controls.length === 1 && showOnlyOne) || readonly ? true : false"
        [matChipInputFor]="chipListTag"
        [matChipInputSeparatorKeyCodes]="teclasSeparadoras"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addNovaTag($event)"
      />
    </mat-chip-set>
  </mat-form-field>
  <!-- <small class="p-error" *ngIf="form.get('tags').hasError('required')">
    teste
  </small> -->
</div>
